import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { ChangeEvent, useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const CopyEntriesForm = () => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  // Sunday is 0, Monday is 1, Tuesday is 2, etc.
  const [state, setState] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: false,
    0: false,
  });

  const {
    1: monday,
    2: tuesday,
    3: wednesday,
    4: thursday,
    5: friday,
    6: saturday,
    0: sunday,
  } = state;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const weekdays = Object.keys(state).filter(
      (key) => state[key as unknown as keyof typeof state],
    );
    setValue(
      "weekdays",
      weekdays.map((day) => parseInt(day)),
    );
  }, [state, setValue]);

  return (
    <>
      <Typography mb={2}>{t("hourEntries:copyForRange")}</Typography>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Controller
          name="startDate"
          control={control}
          render={({ field }) => (
            <DesktopDatePicker
              {...field}
              format="dd.MM.yyyy"
              slotProps={{
                textField: {
                  error: !!errors[field.name],
                  size: "small",
                  sx: {
                    width: "50%",
                  },
                },
              }}
            />
          )}
        />
        <Typography m={1}>{"–"}</Typography>
        <Controller
          name="endDate"
          control={control}
          render={({ field }) => (
            <DesktopDatePicker
              {...field}
              format="dd.MM.yyyy"
              minDate={watch("startDate")}
              slotProps={{
                textField: {
                  error: !!errors[field.name],
                  size: "small",
                  sx: {
                    width: "50%",
                  },
                },
              }}
            />
          )}
        />
      </Box>
      <Typography mt={4} mb={2}>
        {t("hourEntries:selectWeekdays")}
      </Typography>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox checked={monday} onChange={handleChange} name="1" />
          }
          label={t("hourEntries:mon")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={tuesday} onChange={handleChange} name="2" />
          }
          label={t("hourEntries:tue")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={wednesday} onChange={handleChange} name="3" />
          }
          label={t("hourEntries:wed")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={thursday} onChange={handleChange} name="4" />
          }
          label={t("hourEntries:thu")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={friday} onChange={handleChange} name="5" />
          }
          label={t("hourEntries:fri")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={saturday} onChange={handleChange} name="6" />
          }
          label={t("hourEntries:sat")}
        />
        <FormControlLabel
          control={
            <Checkbox checked={sunday} onChange={handleChange} name="0" />
          }
          label={t("hourEntries:sun")}
        />
      </FormGroup>
    </>
  );
};
